import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Sucursal } from '../../model/sucursal';
import { Consorcio } from '../../model/consorcio';
import { ConsorciosService } from '../../services/consorcios.service';
import { SucursalService } from '../../services/sucursal.service';


@Component({
  selector: 'app-sucursal-mantenimiento',
  templateUrl: './sucursal-mantenimiento.component.html',
  styleUrls: ['./sucursal-mantenimiento.component.css']
})
export class SucursalMantenimientoComponent implements OnInit {

  @Input() consorcio: Consorcio = new Consorcio();
  @Input() sucursalSeleccionada: Sucursal;
  @Output() onReturn = new EventEmitter();

  public sucursal: Sucursal = new Sucursal();
  public estadoBorrar: boolean = false;
  public estadoEditar: boolean = false;

  public consorcios: Consorcio[];

  constructor(
    private _consorcioService: ConsorciosService,
    private _sucursalService: SucursalService
  ) { }


  ngOnInit() {
     if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this.sucursal = this.sucursalSeleccionada;
    if (this.sucursal.id != null) {
      this.estadoEditar = true;
    }
  }

  onSubmitSuccess(data: any) {
    this.regresar();
  }

  onSubmit() {
    if (this.sucursal.id === undefined) {
      this.sucursal.id = 0;
    }
    this.sucursal.codigoConsorcio = this.consorcio.codigoConsorcio;
    this._sucursalService.insert(this.sucursal).subscribe(
      result => { 
        if(result.Resultado === "codigoSucursal ya existe en la base de datos"){
            alert("El código de la Sucursal ya existe");
        }else{
          if(result.Resultado === false){
            alert("Ha ocurrido un error...");  
          }else{
            this.onSubmitSuccess(result);
          }
        }
      }
	  
	  ,
      err => {
        console.clear();
        console.log(err._body);
      });
  }

  /* Navegación */

  regresar() {
    this.onReturn.emit();
  }

  solicitaBorrar() {
    this.estadoBorrar = true;
  }

  solicitudBorrarCancelar() {
    this.estadoBorrar = false;
  }

  borrarRegistro() {
    this._sucursalService.delete(this.sucursal).subscribe(
      result => this.regresar(),
      err => {
        console.log(err._body);
      });
  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/sucursal-mantenimiento/sucursal-mantenimiento.component.ts